import { useState } from 'react';
import AssistantResource from 'Resources/AssistantChat';
import NotificationService from 'App/babel/NotificationService';
import logError from 'Helpers/logError';
import { chatOpenStore } from './useChatOpen';

// A new chat on each ask. Without a message nothing is sent, so an unused chat costs no credits.
// With `draft`, the message is left in the composer for the user to edit and send instead.
export function useOpenContextChat(contextType: string, contextId?: number, { draft = false } = {}) {
	const [opening, setOpening] = useState(false);

	const open = async (message?: string) => {
		setOpening(true);
		try {
			const { id } = await AssistantResource.createConversation(contextType, contextId);
			chatOpenStore.openConversation(id, message, { draft });
		} catch (err) {
			logError(err, `useOpenContextChat: could not create the ${contextType} conversation`);
			NotificationService.add({
				style: NotificationService.style.ERROR,
				icon: 'times',
				title: 'default.error',
				body: 'assistant.errorOccurred'
			});
		} finally {
			setOpening(false);
		}
	};

	return { open, opening };
}
